import React from 'react'
import { CaseStudyWrapper } from "./CaseStudy.styles";
import Logo from "../../Global/Layout/Logo/Logo";

/**
 * @param {{
 *   title: string,
 *   quote: string,
 *   name: string,
 *   jobTitleCompany: string | null,
 *   stats: [{
 *     value: string,
 *     label: string
 *   }],
 *   logo: {
 *     fixed: {
 *       src: string,
 *       width: number,
 *       height: number
 *     },
 *     title: string
 *   } | null
 *   image: {
 *     fixed: {
 *       src: string,
 *       width: number,
 *       height: number
 *     },
 *     title: string
 *   } | null
 * }} caseStudy
 * @param {boolean} alt
 * @returns {JSX.Element}
 * @constructor
 */
export default function CaseStudy({ caseStudy, alt }){
  return (
      <CaseStudyWrapper className={alt ? "alt" : ""}>
        <div className="container">
          <div className="logos">
            <Logo variant="dark" />
            {caseStudy.logo &&
                <img src={caseStudy.logo.fixed.src} alt={caseStudy.logo.title} width={caseStudy.logo.fixed.width}
                     height={caseStudy.logo.fixed.height} />}
          </div>

          <div className="grid">
            <h3>{caseStudy.title}</h3>

            <div className="image">
              {caseStudy.image &&
                  <img src={caseStudy.image.fixed.src} alt={caseStudy.image.title} width={caseStudy.image.fixed.width}
                       height={caseStudy.image.fixed.height} />}
            </div>

            <figure>
              <blockquote>
                <p>{caseStudy.quote}</p>
              </blockquote>
              <figcaption>
                <cite>{caseStudy.name}</cite>
                <span>, {caseStudy.jobTitleCompany}</span>
              </figcaption>
            </figure>

            <ul className="stats">
              {(caseStudy.stats ?? []).map((stat, index) => [
                index > 0 &&
                <li key={index + '_separator'} className="separator" aria-hidden="true" role="presentation"></li>,
                <li key={index}>
                  <span className="stat">
                    <strong>{stat.value}</strong>
                    <span className="label">{stat.label}</span>
                  </span>
                </li>
              ])}
            </ul>
          </div>
        </div>
      </CaseStudyWrapper>
  )
}